// KLHS sticky add to cart (sections/klhs-sticky-atc.liquid).
// Mirrors the main product form: shows once its Add to cart button scrolls out of view, follows the selected
// variant, and clicking it presses the real button so quantity, variant and the cart drawer behave as usual.
if (!customElements.get('klhs-sticky-atc')) {
  class KlhsStickyAtc extends HTMLElement {
    connectedCallback() {
      this.main = document.querySelector('[id^="MainProduct-"]');
      this.form = this.main?.querySelector('product-form form');
      this.mainButton = this.main?.querySelector('product-form .product-form__submit');
      if (!this.form || !this.mainButton) return;

      this.product = JSON.parse(document.getElementById(this.dataset.contextId).textContent);
      this.button = this.querySelector('[data-add]');
      this.button.addEventListener('click', () => this.mainButton.click());

      this.update = this.update.bind(this);
      this.form.addEventListener('change', this.update);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(this.update));
      }
      // Dawn re-renders the button for sold-out / unavailable variants; copy its label and state.
      this.buttonObserver = new MutationObserver(this.update);
      this.buttonObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });

      this.desktop = window.matchMedia('(min-width: 990px)');
      this.onResize = () => this.setVisible(this.visible);
      this.desktop.addEventListener('change', this.onResize);

      this.observer = new IntersectionObserver(([entry]) => {
        // Show only once the real button is off screen; above it (scrolled past) or below it (not reached yet).
        this.setVisible(!entry.isIntersecting);
      });
      this.observer.observe(this.mainButton);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.buttonObserver?.disconnect();
      this.unsubscribe?.();
      this.desktop?.removeEventListener('change', this.onResize);
      document.documentElement.style.removeProperty('--klhs-sticky-atc-offset');
    }

    update() {
      const id = this.form.querySelector('[name="id"]')?.value;
      const variant = this.product.variants[id];
      if (variant) {
        const variantEl = this.querySelector('[data-variant]');
        variantEl.textContent = variant.title;
        variantEl.hidden = this.product.hasOnlyDefaultVariant;
        this.querySelector('[data-price]').textContent = variant.price;
      }
      const label = this.mainButton.querySelector('span')?.textContent.trim() || this.mainButton.textContent.trim();
      if (label) this.button.textContent = label;
      this.button.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
    }

    setVisible(visible) {
      this.visible = visible;
      const shown = visible && (!this.desktop.matches || this.classList.contains('klhs-sticky-atc--desktop'));
      this.classList.toggle('klhs-sticky-atc--visible', shown);
      this.toggleAttribute('inert', !shown);
      // Lets other fixed elements (the chat button) sit above the bar.
      document.documentElement.style.setProperty('--klhs-sticky-atc-offset', shown ? `${this.offsetHeight}px` : '0px');
    }
  }

  customElements.define('klhs-sticky-atc', KlhsStickyAtc);
}
